// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__1Dccm","header":"ClearentDisclaimer_header__1XsHZ","inner":"ClearentDisclaimer_inner__12b_p"};